module.exports = __webpack_public_path__ + "static/media/workcompnow-logo.aa4d0512.jpg";